import { useMemo } from "react";

import { useAppSelector } from "../../app/hooks";
import { hasReadAccess, hasWriteAccess } from "../../store/permissionSlice";

/**
 * Hook to check if the user has write access for a given path.
 */
export function useCanWrite(path: string): boolean {
  const pageRoles = useAppSelector(state => state.permissions.pageRoles);
  const roles = useMemo(() => pageRoles[path] ?? [], [pageRoles, path]);
  return hasWriteAccess(roles);
}

/**
 * Hook to check if the user has read access for a given path.
 */
export function useCanRead(path: string): boolean {
  const pageRoles = useAppSelector(state => state.permissions.pageRoles);
  const roles = useMemo(() => pageRoles[path] ?? [], [pageRoles, path]);
  return hasReadAccess(roles);
}
